import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "counter"]
  static values  = { limit: { type: Number, default: 280 }, placeholder: String }

  update() {
    const value = this.inputTarget.value
    if (this.hasCounterTarget) this.counterTarget.textContent = String(this.limitValue - value.length)
    if (this.hasPreviewTarget) {
      this.previewTarget.textContent = value || this.placeholderValue
      this.previewTarget.classList.toggle("text-gimmo-ink-muted", !value)
    }
  }
}
